/**
 * Add Record Button
 * Simple reusable button with link for adding records on record page
 */
import { Link } from 'gatsby';
import React from 'react';

import RoundedButton from '@components/RoundedButton/index';

import { useCuration } from '@hooks/useCuration';

import { LinkWrapper } from './AddRecordButton.style';

const AddRecordButton: React.FC<{
  children: React.ReactNode;
  link: string;
}> = ({ children = null, link = '' }) => {
  const { startAddingRecord } = useCuration();

  return (
    <LinkWrapper>
      <Link to={link}>
        <RoundedButton autoSize iconName="plus" onClick={startAddingRecord}>
          {children}
        </RoundedButton>
      </Link>
    </LinkWrapper>
  );
};

export default AddRecordButton;
